<!--
Copyright (C) 2025 Checkmk GmbH - License: GNU General Public License v2
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import CmkButton from '@/components/CmkButton.vue'
import CmkIcon from '@/components/CmkIcon/CmkIcon.vue'

import { type AiActionButton } from '@/ai/lib/service/ai-template'

defineProps<AiActionButton>()
</script>

<template>
  <CmkButton :variant="variant ?? 'secondary'" :disabled="disabled">
    <CmkIcon :name="executed ? 'alert-up' : 'sparkle'"></CmkIcon>
    <span>{{ action_name }}</span>
  </CmkButton>
</template>
